/*
 * @Author: your name
 * @Date: 2022-03-02 17:03:55
 * @LastEditTime: 2022-09-27 11:55:15
 * @LastEditors: zhaoyu zhaoyu@belink.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \pscd-portal-middle-office\packages\clients\enums\user.ts
 */
/**
 * @export 用户类型
 * @enum
 */
export enum EnumUserSourceType {
  /** 不带bu属性的新用户 */
  bppNew = 'ex55ohg9qfe6feuw',
  /** 带isg属性的新用户 */
  isg = 'lzj9ytl2bi4n4k7d',
  /** 导入进来的rel */
  rel = '110877775',
  /** t1 */
  bppT1 = 'yzc77lqhuaostfqe',
  /** 开发者平台 */
  developer = '8fcinyjdofkarzmv',
  /** DSR */
  dsr = '0dkty4dz4uh26bop',
  /** 云学堂测试（大联想平台（主平台）） */
  yxtSitMain = 'pz13w71y96t',
  /** 云学堂测试（政企（大客户）群平台（子平台其一）） */
  yxtSitRel = 'bdtnmhc4cbr',
  /** 云学堂测试（中小企业平台（子平台其一）） */
  yxtSitMiddle = 'lbg0s51kzrz',
  /** 云学堂测试（消费平台（子平台其一）） */
  yxtSitCon = 'l9a1dj9f1i3',
  /** 云学堂生产（大联想平台（主平台）） */
  yxtProdMain = '77nz5xx9sfu',
  /** 云学堂生产（政企（大客户）群平台（子平台其一）） */
  yxtProdRel = '5ipt7sxlx7y',
  /** 云学堂生产（中小企业平台（子平台其一）） */
  yxtProdMiddle = 'n5m2avdn8mu',
  /** 云学堂生产（消费平台（子平台其一）） */
  yxtProdCon = '560jlzgusfq',
  /** SSG */
  ssg = 'jsiytsogeqk79w32',
  /** 新的云学堂测试(旧) */
  yxtNewSit = 'i8vbepa2087',
  /** 旧的云学堂测试(旧) */
  yxtSit = '9ku57lv6ebm',
  /** 云学堂生产(旧) */
  yxtProd = 'plqkfg71qjf',
}

/**
 * @export 根据用户类型抛出的错误类型
 * @enum
 */
export enum EnumUserErrType {
  /** outh */
  oauth = 1,
  /** 其他 */
  other = 2,
  /** 无sourceappid */
  unLogin = 3,
}

/**
 * @export 获取requestId的场景
 * @enum
 */
export enum EnumRequestIdScene {
  /** 登录 */
  login = 1,
  /** 绑定微信 */
  bindWechat = 2,
}

/**
 * @export 注册来源
 * @enum
 */
export enum EnumRegisterSource {
  /** pc */
  pc = 1,
  /** mobile */
  mobile = 2,
  /** weapp */
  weapp = 3,
}

/**
 * BU
 * @export
 * @enum {number}
 */
export enum EnumBusiness {
  REL = 'BU001',
  CON = 'BU004',
  SMB = 'BU005',
  ISG = 'BU006',
  SSG = 'BU007',
}
